<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelTipoDespesa"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :label="$t('Nome')"
    :allowEmpty="isAllowEmpty"
    :preselectFirst="preselectFirst"
    :loading="isLoading"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    class="multiselect-primary"
    inputContainerClass="d-flex"
    :hide-selected="false"
    :multiple="isMulti"
  >
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="multiselect__tag">
        <span>{{ option.nome }}</span>
        <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
      </span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: {
    nameField: {},
    isRequired: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    emptyLabel: { type: String, default: null },
    includeAll: { type: Boolean, default: false },
    isMulti: { type: Boolean, default: false },
    isObject: { type: Boolean, default: false },
    isTagabble: { type: Boolean, default: false },
    alreadySelected: { type: Boolean, default: false },
    preselectFirst: { type: Boolean, default: false },
    isAllowEmpty: { type: Boolean, default: false }
  },

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_tipo_despesa', null);
        return;
      }
      if (this.isMulti) {
        let arr = new Array();
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_tipo_despesa', arr);
      } else {
        this.isObject
          ? this.$emit('selectChange', 'id_tipo_despesa', e)
          : this.$emit('selectChange', 'id_tipo_despesa', e.id);
      }
      this.$emit('focus');
    },
    labelTipoDespesa({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (value) {
        if (this.isMulti) {
          this.selected = [];
          value.forEach((el) => {
            this.selected.push(this.options.find((option) => option.id === el));
          });
        } else {
          this.selected = this.options.find((option) => option.id === parseInt(value));
        }
      } else {
        if (this.includeAll) {
          this.selected = this.options.find((option) => option.id === null);
        } else {
          this.isMulti ? (this.selected = []) : (this.selected = '');
        }
      }

      this.preselectFirst && !this.isMulti ? this.preselectFirstCheck() : null;
      this.$emit('input', this.selected);
    },

    preselectFirstCheck() {
      this.selected = this.options[0];
    },

    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('tipo_despesa', {
          columns: 'id, nome',
          order: 'id'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: `${err.code} - ${err.message}`,
            msgTranslate: false,
            type: 'error'
          });
        });
    }
  },

  watch: {
    nameField(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.options.length > 0) {
          this.setValue(this.nameField);
        } else {
          this.setOptions();
        }
      }
    }
  },

  created() {
    this.setOptions();
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
